import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NOTIFICATIONS_COUNT_FEATURE_KEY, NotificationsCountState } from './notifications-count.state';

const selectNotificationsCountState = createFeatureSelector<NotificationsCountState>(NOTIFICATIONS_COUNT_FEATURE_KEY);

export const selectNotificationBellCount = createSelector(selectNotificationsCountState, state => state.unreadCount);
